import React from 'react';
import { Grid } from '@material-ui/core';
import { Typography } from '@kareo/design-system';
import { formatISODateShort } from 'shared-assets/facesheet-ui/utils/patientHelper';
import FacesheetCardFooter from 'shared-assets/facesheet-ui/components/Facesheet/Card/FacesheetCardFooter';
function getMeasurementLabels(vitalsMeasurements) {
    var measurementLabels = [];
    if (vitalsMeasurements.bloodPressureSystolic !== null &&
        vitalsMeasurements.bloodPressureDiastolic !== null) {
        measurementLabels.push({
            key: 'BP',
            value: vitalsMeasurements.bloodPressureSystolic + " / " + vitalsMeasurements.bloodPressureDiastolic,
        });
    }
    if (vitalsMeasurements.heartRate !== null) {
        measurementLabels.push({
            key: 'HR',
            value: vitalsMeasurements.heartRate + " bpm",
        });
    }
    if (vitalsMeasurements.temperature !== null) {
        measurementLabels.push({
            key: 'Temp',
            value: vitalsMeasurements.temperature + " F",
        });
    }
    if (vitalsMeasurements.respiratoryRate !== null) {
        measurementLabels.push({
            key: 'RR',
            value: vitalsMeasurements.respiratoryRate + " rpm",
        });
    }
    if (vitalsMeasurements.heightInFeet !== null) {
        var heightValue = vitalsMeasurements.heightInFeet + "'";
        if (vitalsMeasurements.heightInInches !== null) {
            heightValue += " " + vitalsMeasurements.heightInInches + "\"";
        }
        measurementLabels.push({
            key: 'Ht/Lt',
            value: heightValue,
        });
    }
    if (vitalsMeasurements.weight !== null) {
        var weightValue = vitalsMeasurements.weight + " lbs";
        if (vitalsMeasurements.weightInOunces !== null) {
            weightValue += " " + vitalsMeasurements.weightInOunces + " oz";
        }
        measurementLabels.push({
            key: 'Wt',
            value: weightValue,
        });
    }
    if (vitalsMeasurements.bmi !== null) {
        measurementLabels.push({
            key: 'BMI',
            value: "" + vitalsMeasurements.bmi,
        });
    }
    if (vitalsMeasurements.pediatricHeadCirc !== null) {
        measurementLabels.push({
            key: 'Head Circ',
            value: vitalsMeasurements.pediatricHeadCirc + " inches",
        });
    }
    if (vitalsMeasurements.spo2 !== null) {
        measurementLabels.push({
            key: 'SpO2',
            value: vitalsMeasurements.spo2 + "%",
        });
    }
    if (vitalsMeasurements.inhaledOxygenConcentration !== null) {
        measurementLabels.push({
            key: 'Inhaled O2',
            value: vitalsMeasurements.inhaledOxygenConcentration + "%",
        });
    }
    return measurementLabels;
}
function getVitalsData(vitalsData) {
    if (Array.isArray(vitalsData))
        return vitalsData[0];
    return vitalsData;
}
var VitalsContent = function (_a) {
    var vitalsData = _a.vitalsData;
    var mostRecentVitalRecord = getVitalsData(vitalsData);
    var measurementLabels = (mostRecentVitalRecord === null || mostRecentVitalRecord === void 0 ? void 0 : mostRecentVitalRecord.vitalsMeasurements) ? getMeasurementLabels(mostRecentVitalRecord.vitalsMeasurements)
        : [];
    return (React.createElement(Grid, { container: true }, !mostRecentVitalRecord ? (React.createElement(Grid, { item: true, xs: 12 },
        React.createElement(Typography, { variant: "body1" }, "(None documented)"))) : (React.createElement(Grid, { item: true, xs: 12 },
        React.createElement(Grid, { container: true, spacing: 1 },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(Grid, { container: true }, measurementLabels.map(function (measurement) {
                    return (React.createElement(Grid, { item: true, xs: 5, key: measurement.key },
                        React.createElement(Typography, { variant: "h4", display: "inline" }, measurement.key),
                        React.createElement(Typography, { display: "inline" },
                            ": ",
                            measurement.value)));
                }))),
            (mostRecentVitalRecord === null || mostRecentVitalRecord === void 0 ? void 0 : mostRecentVitalRecord.comments) && (React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(Typography, { variant: "h4", display: "inline" }, "Comments"),
                React.createElement(Typography, { display: "inline" },
                    ": ",
                    mostRecentVitalRecord.comments))),
            (mostRecentVitalRecord === null || mostRecentVitalRecord === void 0 ? void 0 : mostRecentVitalRecord.recordedDate) && (React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(FacesheetCardFooter, { text: "Last updated " + formatISODateShort(mostRecentVitalRecord.recordedDate) }))))))));
};
export default VitalsContent;
